<template>
  <section
      v-if="Object.keys(selectedService).length > 0"
      class="grid lg:grid-cols-[30%_1fr] md:grid-cols-[50%_1fr] sm:grid-cols-1 gap-8 w-full"
  >
    <section class="flex flex-col gap-6 top-0">
      <card padding="" class="flex flex-col h-fit">
        <div class="flex flex-col gap-1 border-b border-gray-400/50 px-8 py-4">
          <div class="flex flex-row gap-2 items-center justify-between">
            <span class="text-xxs italic font-semibold">
              {{ selectedService.source_service.name_format }}
            </span>
            <div class="flex flex-row">
              <rpm-button
                  no-border
                  class="rounded-full h-6 w-6 mr-3"
                  color="gray"
                  font-class="text-sm"
                  icon="fa-solid fa-pen-to-square"
                  tooltip-text="alterar"
                  @click="modalChangeService(selectedService)"
                  v-if="selectedService.can_be_canceled && $can('services.change.source_service')"
              ></rpm-button>
              <rpm-button
                  no-border
                  class="rounded-full h-6 w-6"
                  color="red"
                  font-class="text-sm"
                  icon="fa-solid fa-xmark"
                  tooltip-text="cancelar"
                  @click="modalOpen(selectedService)"
                  v-if="selectedService.can_be_canceled && !selectedService.canceled && $can('services.service.cancel')"
              ></rpm-button>
            </div>
          </div>
          <span class="text-xl font-bold">
            {{ selectedService.source_service.name }}
          </span>
          <div class="mt-2 flex flex-col gap-2 text-sm">
            <span>
              <b> Serviço Nº: </b>
              <copy-span class="text-md underline decoration-2 decoration-theme">
                {{ selectedService.id }}
              </copy-span>
            </span>
            <span v-if="selectedService.ticket_number">
              <b> Protocolo de atendimento: </b>
              <copy-span class="text-md underline decoration-2 decoration-theme">
                {{ selectedService.ticket_number }}
              </copy-span>
            </span>
            <span class="line">
              <i class="fa-solid fa-calendar-days"></i>
              <b> Início: </b>
              {{ formatDate(selectedService.started_at, "DD/MM/YYYY HH:mm") }}
            </span>
            <span class="line" v-if="selectedService.finished_at">
              <i class="fa-solid fa-calendar-check"></i>
              <b> Finalizado: </b>
              {{ formatDate(selectedService.finished_at, "DD/MM/YYYY HH:mm") }}
            </span>
            <span class="line">
              <i class="fa-solid fa-comments"></i>
              <b> Meio de Solicitação: </b>
              {{ selectedService.attendance_channel.name }}
            </span>
            <span class="line">
              <i class="fa-solid fa-person-chalkboard"></i>
              <b> Solicitante: </b>
              {{
                selectedService.person
                    ? selectedService.person.name
                    : selectedService.asked_by
              }}
            </span>
          </div>
        </div>
        <rpm-time-line
            :data="selectedService.procedures"
            v-slot="{ item: procedure, index }"
            class="mx-8 my-8"
            :actual="actual"
            actual-class=""
            :actualfirst-node-class="selectedService.procedures[0].executed_at ? 'bg-green-500' : 'bg-red-500'"
            actual-not-first-node-class="bg-green-500"
            actual-last-node-class="bg-green-500"
            :first-node-class="selectedService.procedures[0].executed_at ? 'border-green-500':'border-red-500'"
            not-first-node-class="border-green-500"
            node-class=""
        >
          <section class="flex flex-col gap-2">
            <div class="flex flex-row justify-between gap-2">
              <div
                  class="line gap-x-2 group text-md font-semibold w-fit transition-all"
                  :class="{
                    'cursor-pointer': canSeeProcedure(procedure),
                    'cursor-not-allowed opacity-60': !canSeeProcedure(procedure)
                  }"
                  @click="setProcedure(index, procedure)"
              >
                <span
                    class="group-hover:underline decoration-2"
                >
                  {{ procedure.source_procedure.name }}
                </span>
                <badge
                    class="bg-theme/10 border border-theme"
                    text-size="text-xxs"
                    text-color="text-theme"
                    padding="px-1 py-0.5"
                >
                  {{ procedure.id }}
                </badge>
              </div>

              <rpm-button
                  v-if="false"
                  no-border
                  class="rounded-full h-6 w-6"
                  font-class="text-xs"
                  icon="fa-solid fa-arrow-right-arrow-left"
                  tooltip-text="transferir"
                  @click="changeOrganization(procedure)"
              ></rpm-button>
            </div>
            <span class="line text-xs">
              <template v-if="procedure.executed_at">
                <i class="fa-solid fa-calendar-day"></i>
                <b>Executado:</b>
                {{ formatDate(procedure.executed_at, "DD/MM/YYYY HH:mm") }}
              </template>
              <template v-else>
                <i class="fa-solid fa-hourglass-half"></i>
                <b>Prazo:</b>
                {{ addDays(selectedService.last_procedure.executed_at, procedure.source_procedure.execution_deadline) }}
              </template>
            </span>
            <span class="line text-xs gap-y-3" v-if="procedure.current_organization">
                <i class="fa-solid fa-building"></i>
                <b>Organização atual: {{ procedure.current_organization.name }}</b>
            </span>
            <span class="line text-xs" v-if="procedure.organizations_history" :key="index">
                <i class="fa-solid fa-calendar-day"></i>
                <b>Organização anterior: {{ procedure.organizations_history?.name }}</b>
            </span>
            <span class="line text-xs mb-4" v-if="procedure.organizations_history" :key="index">
                <i class="fa-solid fa-calendar-day"></i>
                <b>movido em {{ formatDate(procedure.organizations_history?.moved_at, "DD/MM/YYYY") }}</b>
            </span>
          </section>

        </rpm-time-line>
        <div class="flex gap-2 p-4 ">
          <badge :color="selectedService.service_priority.color">
            {{ selectedService.service_priority.name }}
          </badge>
          <badge :color="'#344767'">
            {{ selectedService.service_status.name }}
          </badge>
          <badge v-if="selectedService.group" class="bg-theme">
            {{ selectedService.grouped_message }}
          </badge>
          <badge v-if="selectedService.old_service_request" class="bg-theme">
            Origem: {{ selectedService.old_service_request }}
          </badge>
          <badge v-if="selectedService.new_service_request" class="bg-theme">
            Movido para: {{ selectedService.new_service_request }}
          </badge>
          <badge v-if="selectedService.service_origin" :color="selectedService.service_origin.color">
            {{ selectedService.service_origin.name }}
          </badge>
        </div>
      </card>

      <rpm-accordion
          header="Endereço"
          header-class="flex flex-row items-center justify-between font-bold border-b border-gray-400/50 px-8 py-4"
          icon="fa-solid fa-angle-down"
          open-icon-class="rotate-180"
          class="bg-white dark:bg-slate-900"
      >
        <div class="flex flex-col gap-2 p-6 text-sm">
          <span v-if="selectedService.address.neighborhood.city">
            <b>Cidade: </b>
            {{
              selectedService.address.neighborhood.city +
              (
                  selectedService.address.neighborhood.state ?
                      ', ' + selectedService.address.neighborhood.state : ''
              )
            }}
          </span>

          <span v-if="selectedService.address.neighborhood.name">
            <b>Endereço: </b>
            {{
              selectedService.address.neighborhood.name +
              (
                  selectedService.address.address ?
                      ', ' + selectedService.address.address : ''
              ) +
              (
                  selectedService.address.number ?
                      ', Número ' + selectedService.address.number : ''
              )
            }}
          </span>

          <span v-if="selectedService.address.complement" class="line">
            <b>Complemento:</b>
            {{ selectedService.address.complement }}
          </span>

          <span v-if="selectedService.address.reference_point" class="line">
            <b>Ponto De Referência:</b>
            {{ selectedService.address.reference_point }}
          </span>

          <span v-if="selectedService.address.zipcode" class="line">
            <b>Cep:</b>
            {{ selectedService.address.zipcode }}
          </span>

          <span v-if="selectedService.address.coordinates" class="line">
            <b>Coordenadas:</b>
            {{ selectedService.address.coordinates }}
          </span>
        </div>
      </rpm-accordion>

      <rpm-accordion
          header="Comentários"
          header-class="flex flex-row items-center justify-between font-bold border-b border-gray-400/50 px-8 py-4"
          icon="fa-solid fa-angle-down"
          open-icon-class="rotate-180"
          color="red-hover"
          class="bg-white dark:bg-slate-900"
      >
        <div class="flex flex-col gap-6 px-6 py-5 text-sm">
          <Comments :comments="comments" @delete="deleteComment"/>
          <div class="flex flex-row gap-2 items-center" @keyup.ctrl.enter="addComment">
            <rpm-input
                type="textarea"
                placeholder="Mensagem"
                v-model="message"
                class="w-full"
            ></rpm-input>

            <rpm-button
                no-border
                icon="fa-solid fa-paper-plane"
                class="rounded-full h-6 w-6"
                font-class="text-xs"
                @click="addComment"
                tooltip-text="enviar"
            ></rpm-button>
          </div>
        </div>
      </rpm-accordion>
    </section>

    <executor
        v-if="selectedService.procedures[actual] && canSeeProcedure(selectedService.procedures[actual])"
        :procedure="selectedService.procedures[actual]"
        @procedure-executed="getService"
        @questionnaire-change="getService"
        @deleted="getService"
        @edited="getService"
    ></executor>
  </section>

  <cancel-service-modal
      :service="selectedService"
      :open="openModal"
      @canceled="getService"
      @close="openModal = false"
  ></cancel-service-modal>

  <rpm-modal
      header="Alterar serviço"
      class="grid grid-cols-2 gap-x-4 gap-y-8"
      :open="changeServiceModal"
      @close="changeServiceModal = false"
  >
    <rpm-input
        label="Motivo"
        required
        v-model="changeForm.reason"
        :errors="errors.reason"
    />
    <rpm-input
        type="select"
        label="Serviço selecionado"
        :options="allSourceServices"
        optionLabel="name_format"
        optionValue="id"
        v-model="changeForm.intended_service_id"
        required
        :errors="errors.intended_service_id"
    />

    <template #buttons>
      <rpm-button
          color="blue"
          label="Alterar"
          @click="changeService"
          :disabled="buttonDisabled"
      />
    </template>
  </rpm-modal>

  <change-organization
      :modalOpen="changeOrganizationModalOpen"
      @organization-changed="organizationChanged"
      :procedure="selectedProcedure"
      @close="changeOrganizationModalOpen = false"
  />
</template>

<script>
import Executor from "./executor";
import Badge from "#components/Badge.vue";
import RpmTimeLine from "#components/RpmTimeLine.vue";
import RpmAccordion from "#components/RpmAccordion.vue";
import RpmModal from "#components/RpmModal.vue";
import Comments from "./comments";

import serviceRepository from "#repositories/serviceRepository";
import commentsRepository from "#repositories/commentsRepository";
import sourceServiceRepository from "#repositories/sourceServiceRepository";

import { formatDate } from "#functions/formatter.js";

import moment from "moment/moment";
import _ from "lodash";

import CancelServiceModal from "#views/service/modals/cancel.vue";
import ChangeOrganization from "#views/service/modals/changeOrganization.vue";

export default {
  name: "ServicesExecution",
  components: {
    Badge,
    Executor,
    RpmTimeLine,
    RpmAccordion,
    RpmModal,
    CancelServiceModal,
    Comments,
    ChangeOrganization
  },
  data() {
    return {
      selectedService: {},
      selectedSourceService: {},
      allSourceServices: {},
      actual: null,
      openModal: false,
      changeServiceModal: false,
      message: '',
      comments: [],
      changeOrganizationModalOpen: false,
      selectedProcedure: {},
      changeForm: {},
      services: [],
      errors: [],
      buttonDisabled: false
    };
  },
  methods: {
    formatDate(...params) {
      return formatDate(...params);
    },

    // ===== PERMISSÕES BASEADAS EM source_procedure.actions =====
    getProcedureActions(procedure) {
      if (!procedure) return {};
      // actions vem dentro de procedure.source_procedure.actions
      if (procedure.source_procedure && procedure.source_procedure.actions) {
        return procedure.source_procedure.actions;
      }
      // fallback se em algum caso vier direto
      if (procedure.actions) return procedure.actions;
      return {};
    },
    canSeeProcedure(procedure) {
      const actions = this.getProcedureActions(procedure);
      return !!actions.see;
    },
    canExecuteProcedure(procedure) {
      const actions = this.getProcedureActions(procedure);
      // precisa ter execute = true E permissão global
      return !!actions.execute && this.$can('services.procedure.execute');
    },
    canEditProcedure(procedure) {
      const actions = this.getProcedureActions(procedure);
      return !!actions.edit && this.$can('services.procedure.edit');
    },

    setProcedure(index, procedure) {
      // 1) não pode nem abrir se não tiver SEE
      if (!this.canSeeProcedure(procedure)) {
        this.$notify('Você não tem permissão para visualizar este procedimento', 'warn');
        return;
      }

      // 2) se ainda NÃO foi executado, só pode abrir se puder EXECUTAR
      if (!procedure.executed_at && !this.canExecuteProcedure(procedure)) {
        this.$notify('Você não pode executar este procedimento', 'warn');
        return;
      }

      this.actual = index;
    },

    async getService() {
      this.selectedService = (
          await serviceRepository.getService(this.$route.params.service_id)
      ).data;

      this.openModal = false;

      const procedures = this.selectedService.procedures || [];

      // tenta pegar o ÚLTIMO procedimento não executado em que posso ver + executar
      let idx = _.findLastIndex(
          procedures,
          (p) => !p.executed_at && this.canSeeProcedure(p) && this.canExecuteProcedure(p)
      );

      // se não achar, pega o último que pelo menos posso ver
      if (idx === -1) {
        idx = _.findLastIndex(
            procedures,
            (p) => this.canSeeProcedure(p)
        );
      }

      this.actual = idx === -1 ? null : idx;
    },

    async getComments() {
      this.comments = (
          await commentsRepository.getServiceComments(this.$route.params.service_id)
      ).data;
    },

    async getAllSourceServices() {
      if (this.selectedService.person) {
        return (this.allSourceServices = (
            await sourceServiceRepository.getAllSourceServices()
        ).data);
      }
      return (this.allSourceServices = (
          await sourceServiceRepository.getAnonymousSourceServices({
            with_person: !!this.selectedService.person,
          })
      ).data);
    },

    organizationChanged() {
      this.changeOrganizationModalOpen = false
      this.getService()
    },

    addComment() {
      commentsRepository
          .storeComment(this.$route.params.service_id, this.message)
          .then((response) => {
            this.message = '';
            this.comments.push(response.data);
            this.$notify('Comentário enviado', 'success');
          })
          .catch(() => {
            this.$notify('Erro ao enviar o comentário', 'error');
          });
    },

    deleteComment(id) {
      commentsRepository
          .deleteComment(id)
          .then((response) => {
            this.comments[
                _.findIndex(this.comments, (comment) => comment.id == response.data.id)
                ] = response.data;

            this.$notify('Comentário apagado', 'success');
          })
          .catch(() => {
            this.$notify('Erro ao apagar comentário', 'error');
          });
    },

    changeService() {
      this.buttonDisabled = true;
      serviceRepository
          .changeService(this.$route.params.service_id, this.changeForm)
          .then((response) => {
            this.$notify('Serviço alterado', 'success');
            this.changeServiceModal = false;
            this.$router.push({
              name: 'ServicesExecution',
              params: { service_id: response.data.id },
            });
          })
          .catch((error) => {
            this.errors = error.errors;
            this.$notify('Erro ao alterar o serviço', 'error');
          })
          .finally(() => {
            this.buttonDisabled = false;
          });
    },

    addDays(dateTime, value) {
      if (value) return moment(dateTime).add(value, "days").format("DD/MM/YYYY HH:mm");
    },

    modalOpen(item) {
      this.openModal = true;
      this.selectedService = item;
    },

    modalChangeService(item) {
      this.changeServiceModal = true;
      if (item.person) {
        this.changeForm.person_id = item.person.id;
      }
    },

    changeOrganization(procedure) {
      this.changeOrganizationModalOpen = true;
      this.selectedProcedure = procedure;
    },
  },
  watch:{
    selectedService(){
      this.getAllSourceServices();
    }
  },
  mounted() {
    this.getService();
    this.getComments();
  },
};
</script>
